var map = {
	"./jdf/images/btn/game_gchess.jpg": 509,
	"./jdf/images/btn/game_gchess_x.jpg": 510,
	"./jdf/images/btn/game_gegame.jpg": 511,
	"./jdf/images/btn/game_gegame_x.jpg": 512,
	"./jdf/images/btn/game_gfish.jpg": 513,
	"./jdf/images/btn/game_gfish_x.jpg": 514,
	"./jdf/images/btn/game_glive.jpg": 515,
	"./jdf/images/btn/game_glive_x.jpg": 516,
	"./jdf/images/btn/game_glotto.jpg": 517,
	"./jdf/images/btn/game_glotto_x.jpg": 518,
	"./jdf/images/btn/game_gsport.jpg": 519,
	"./jdf/images/btn/game_gsport_x.jpg": 520,
	"./jdf/images/event/fifa2026/mb-banner.jpg": 521,
	"./jdf/images/event/fifa2026/pc-banner.jpg": 334,
	"./jdf/images/event/fifa2026/quiz_header.jpg": 522,
	"./jdf/images/event/fifa2026/quiz_header_m.jpg": 523,
	"./jdf/images/event/fifa2026/step-1_m.jpg": 524,
	"./jdf/images/festival/quiz/B/qu_ar.jpg": 525,
	"./jdf/images/festival/quiz/B/qu_au.jpg": 526,
	"./jdf/images/festival/quiz/B/qu_be.jpg": 527,
	"./jdf/images/festival/quiz/B/qu_br.jpg": 528,
	"./jdf/images/festival/quiz/B/qu_ca.jpg": 529,
	"./jdf/images/festival/quiz/B/qu_ch.jpg": 530,
	"./jdf/images/festival/quiz/B/qu_cm.jpg": 531,
	"./jdf/images/festival/quiz/B/qu_cr.jpg": 532,
	"./jdf/images/festival/quiz/B/qu_de.jpg": 533,
	"./jdf/images/festival/quiz/B/qu_dk.jpg": 534,
	"./jdf/images/festival/quiz/B/qu_ec.jpg": 535,
	"./jdf/images/festival/quiz/B/qu_es.jpg": 536,
	"./jdf/images/festival/quiz/B/qu_fr.jpg": 537,
	"./jdf/images/festival/quiz/B/qu_gb-eng.jpg": 538,
	"./jdf/images/festival/quiz/B/qu_gb-wls.jpg": 539,
	"./jdf/images/festival/quiz/B/qu_gh.jpg": 540,
	"./jdf/images/festival/quiz/B/qu_hr.jpg": 541,
	"./jdf/images/festival/quiz/B/qu_ir.jpg": 542,
	"./jdf/images/festival/quiz/B/qu_jp.jpg": 543,
	"./jdf/images/festival/quiz/B/qu_kr.jpg": 544,
	"./jdf/images/festival/quiz/B/qu_ma.jpg": 545,
	"./jdf/images/festival/quiz/B/qu_mx.jpg": 546,
	"./jdf/images/festival/quiz/B/qu_nl.jpg": 547,
	"./jdf/images/festival/quiz/B/qu_pl.jpg": 548,
	"./jdf/images/festival/quiz/B/qu_pt.jpg": 549,
	"./jdf/images/festival/quiz/B/qu_qa.jpg": 550,
	"./jdf/images/festival/quiz/B/qu_rs.jpg": 551,
	"./jdf/images/festival/quiz/B/qu_sa.jpg": 552,
	"./jdf/images/festival/quiz/B/qu_sn.jpg": 553,
	"./jdf/images/festival/quiz/B/qu_tn.jpg": 554,
	"./jdf/images/festival/quiz/B/qu_us.jpg": 555,
	"./jdf/images/festival/quiz/B/qu_uy.jpg": 556,
	"./jdf/images/festival/quiz/quiz_header.jpg": 338,
	"./jdf/images/festival/quiz/quiz_header_m.jpg": 339,
	"./jdf/images/festival/quiz/step-1_m.jpg": 340,
	"./jdf/images/festival/xmas/xmas-red.jpg": 557,
	"./jdf/images/game/desktop/product_127.jpg": 558,
	"./jdf/images/hot/tool-539.jpg": 559,
	"./jdf/images/hot/tool-appset.jpg": 560,
	"./jdf/images/hot/tool-check.jpg": 561,
	"./jdf/images/hot/tool-just8899.jpg": 562,
	"./jdf/images/hot/tool-know.jpg": 563,
	"./jdf/images/hot/tool-qa.jpg": 564,
	"./jdf/images/hot/tool-time.jpg": 565,
	"./jdf/images/hot/tool-youtube.jpg": 566,
	"./jdf/images/jpeg/game/desktop/product_1.jpg": 567,
	"./jdf/images/jpeg/game/desktop/product_10.jpg": 568,
	"./jdf/images/jpeg/game/desktop/product_11.jpg": 569,
	"./jdf/images/jpeg/game/desktop/product_12.jpg": 570,
	"./jdf/images/jpeg/game/desktop/product_13.jpg": 571,
	"./jdf/images/jpeg/game/desktop/product_14.jpg": 572,
	"./jdf/images/jpeg/game/desktop/product_15.jpg": 573,
	"./jdf/images/jpeg/game/desktop/product_16.jpg": 574,
	"./jdf/images/jpeg/game/desktop/product_17.jpg": 575,
	"./jdf/images/jpeg/game/desktop/product_18.jpg": 576,
	"./jdf/images/jpeg/game/desktop/product_19.jpg": 577,
	"./jdf/images/jpeg/game/desktop/product_2.jpg": 578,
	"./jdf/images/jpeg/game/desktop/product_20.jpg": 579,
	"./jdf/images/jpeg/game/desktop/product_21.jpg": 580,
	"./jdf/images/jpeg/game/desktop/product_22.jpg": 581,
	"./jdf/images/jpeg/game/desktop/product_23.jpg": 582,
	"./jdf/images/jpeg/game/desktop/product_24.jpg": 583,
	"./jdf/images/jpeg/game/desktop/product_25.jpg": 584,
	"./jdf/images/jpeg/game/desktop/product_26.jpg": 585,
	"./jdf/images/jpeg/game/desktop/product_27.jpg": 586,
	"./jdf/images/jpeg/game/desktop/product_28.jpg": 587,
	"./jdf/images/jpeg/game/desktop/product_3.jpg": 588,
	"./jdf/images/jpeg/game/desktop/product_30.jpg": 589,
	"./jdf/images/jpeg/game/desktop/product_36.jpg": 590,
	"./jdf/images/jpeg/game/desktop/product_4.jpg": 591,
	"./jdf/images/jpeg/game/desktop/product_5.jpg": 592,
	"./jdf/images/jpeg/game/desktop/product_6.jpg": 593,
	"./jdf/images/jpeg/game/desktop/product_7.jpg": 594,
	"./jdf/images/jpeg/game/desktop/product_8.jpg": 595,
	"./jdf/images/jpeg/game/desktop/product_9.jpg": 596,
	"./jdf/images/jpeg/game/mobile/product_1.jpg": 597,
	"./jdf/images/jpeg/game/mobile/product_11.jpg": 598,
	"./jdf/images/jpeg/game/mobile/product_12.jpg": 599,
	"./jdf/images/jpeg/game/mobile/product_13.jpg": 600,
	"./jdf/images/jpeg/game/mobile/product_17.jpg": 601,
	"./jdf/images/jpeg/game/mobile/product_2.jpg": 602,
	"./jdf/images/jpeg/game/mobile/product_22.jpg": 603,
	"./jdf/images/jpeg/game/mobile/product_23.jpg": 604,
	"./jdf/images/jpeg/game/mobile/product_24.jpg": 605,
	"./jdf/images/jpeg/game/mobile/product_25.jpg": 606,
	"./jdf/images/jpeg/game/mobile/product_27.jpg": 607,
	"./jdf/images/jpeg/game/mobile/product_3.jpg": 608,
	"./jdf/images/jpeg/game/mobile/product_4.jpg": 609,
	"./jdf/images/jpeg/game/mobile/product_5.jpg": 610,
	"./jdf/images/jpeg/game/mobile/product_6.jpg": 611,
	"./jdf/images/jpeg/game/mobile/product_7.jpg": 612,
	"./jdf/images/jpeg/game/mobile/tool-just8899.jpg": 613,
	"./jdf/images/jpeg/mobile/product_2.jpg": 614,
	"./jdf/images/mobile/h_product_1.jpg": 615,
	"./jdf/images/mobile/h_product_2.jpg": 616,
	"./jdf/images/mobile/h_product_29.jpg": 617,
	"./jdf/images/mobile/h_product_45.jpg": 618,
	"./jdf/images/mobile/h_product_66.jpg": 619,
	"./jdf/images/mobile/h_product_71.jpg": 620,
	"./jdf/static/icons/open-graph-img.jpg": 621,
	"./jdf/static/images/error.jpg": 622
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 508;